import React from 'react';
import { ApplicationPage } from '../../components/applications/ApplicationPage';
import { leadershipPage } from '../../data/applicationPages';
export function LeadershipPage() {
  return <ApplicationPage content={leadershipPage} data-id="element-1914" data-mp="1lbg7ahidvta6" />;
}